export default __webpack_public_path__ + "static/media/113-funeral.8b1b79f7.svg";